import { profileActionExtension } from '@interhyp/api-account';
import { Settings } from '@interhyp/platform-icons';
import { modalExtension, OPEN_MODAL } from '@interhyp/platform-modal';
import { createModule } from '@interhyp/platform-module';
import { lazy } from 'react';

const CONSENT_MANAGER_MODAL = 'consent-manager-modal';

export default createModule({
  name: 'portal-interim-home-consent-manager',
  extensions: [
    profileActionExtension.createExtension({
      title: 'Cookies',
      icon: <Settings />,
      action: () => {
        OPEN_MODAL.emit({ id: CONSENT_MANAGER_MODAL });
      },
    }),
    modalExtension.createExtension({
      id: CONSENT_MANAGER_MODAL,
      modal: lazy(() => import('./ConsentManagerModal')),
    }),
  ],
});
